import React from "react";

import ProgressCircle from "@/components/progressCircle";
import { cn } from "../utils";
import { MoveRight } from "lucide-react";

const PrepaidIndicator = ({ currentAmount = 0, pendingAdjustment = 0 }) => {
  const potentialAmount = currentAmount + pendingAdjustment;
  const hasAdjustment = pendingAdjustment !== 0;
  const isOverdraft = potentialAmount < 0;
  const isAdding = pendingAdjustment > 0;

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <div>
          <ProgressCircle
            value={isAdding ? currentAmount / potentialAmount : 1}
            max={1}
            radius={30}
          >
            <div className="flex flex-col items-center">
              <div className="font-bold tracking-tight">{currentAmount}</div>
              <div>SEK</div>
            </div>
          </ProgressCircle>
        </div>
        {hasAdjustment && (
          <div className="flex flex-col items-center">
            <span
              className={cn("text-lg font-semibold", {
                "text-success": hasAdjustment && pendingAdjustment > 0,
                "text-destructive": isOverdraft,
              })}
            >
              {pendingAdjustment > 0
                ? `+${pendingAdjustment}`
                : pendingAdjustment}{" "}
              SEK
            </span>
            <MoveRight size={16} className="text-slate-400" />
          </div>
        )}
        {hasAdjustment && (
          <div
            className={cn({
              "text-destructive": isOverdraft,
              "text-success": !isOverdraft && isAdding,
            })}
          >
            <ProgressCircle
              value={potentialAmount / currentAmount || 0}
              max={1}
              radius={30}
              variant={isOverdraft ? "error" : isAdding ? "success" : undefined}
            >
              <div className="flex flex-col items-center">
                <div className="font-bold tracking-tight">
                  {potentialAmount}
                </div>
                <div>SEK</div>
              </div>
            </ProgressCircle>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrepaidIndicator;
